import React from 'react';
import SocialMedia from '../components/SocialMedia';
import {ReactComponent as Mouse} from "../media/graphics/mouse.svg";

function Connect() {
    return (
        <main className="contact page">
            <section className="section-wrapper connect">
                <div className="connect-wrapper">
                    <h1>Connect</h1>
                    <p>Say hi and get in touch with me!</p>
                    
                    <SocialMedia />
                    <Mouse className="mouse"/>
                </div>
                
            </section>

            <section className="section-wrapper say-hi">
                <h2>Say Hi</h2>
                <p>Have new ideas? Let's chat and connect!</p>
                <a href="mailto:kirstenkdn@gmail.com" className="btn mail-to">Get in Touch!</a>
            </section> 
        </main>
    )
}

export default Connect
